import React from "react";

const SubscriptionRadio = (
    {
        name,
        type,
        selected,
        onClick,
        bgColor = "ea_yellow",
        textColor = "black",
    }
) => {

    const handleClick = () => {
        onClick && onClick(type);
    }

    return (
        <div className={`border-2 ${selected ? "border-ea_green_to" : "border-transparent"} rounded-xl`}>
            <div
                className={`bg-${bgColor} cursor-pointer select-none border-8 border-white rounded-xl flex flex-col items-center p-4 text-${textColor} ${selected ? "shadow-xl" : ""}`}
                onClick={handleClick}>
                <div className="text-xs leading-none uppercase">Abbonamento</div>
                <div className="font-bold text-lg leading-none mt-1 mb-2 uppercase">{name}</div>
                <div className="h-4 w-4 bg-white rounded-full flex flex-col items-center justify-center">
                    {selected && <div className="h-3 w-3 rounded-full bg-ea_green_to"/>}
                </div>
            </div>
        </div>
    );
}

export default SubscriptionRadio;
